import AppSearchResultsMobilePopup from '../ui/AppSearchResultsMobilePopup.vue';
import { usePopups } from '@mm-frontend/mm-web-ui-kit';
import { AppSearchController } from './AppSearchController';
import { EAppSearchResultsMode } from '../models/EAppSearchResultsMode';
import { useDebounceFn } from '@vueuse/core';
import { readonly } from 'vue';
import { useSearchHistoryStore } from '~/features/store/search-history';

const { createPopup } = usePopups();
const { pushSearchHistoryValue, removeSearchHistoryValue, clearSearchHistory } = useSearchHistoryStore();

const appSearchController = new AppSearchController({
  addToSearchHistory: pushSearchHistoryValue,
  removeFromSearchHistory: removeSearchHistoryValue,
  clearSearchHistory: clearSearchHistory,
});

const searchResultsPopup = createPopup({
  component: AppSearchResultsMobilePopup,
})

appSearchController.setPopup(searchResultsPopup);

const isResultsOpened = readonly(appSearchController.isOpened);

const isResultsInMenuMode = computed(() => {
  return appSearchController.mode.value === EAppSearchResultsMode.MENU;
});

const isResultsInPopupMode = computed(() => {
  return appSearchController.mode.value === EAppSearchResultsMode.POPUP;
});

function toggleSearchResults() {
  appSearchController.toggle();
}

function openSearchResults() {
  appSearchController.open();
}

function closeSearchResults() {
  appSearchController.close();
}

function setSearchResultsMode(mode: EAppSearchResultsMode) {
  appSearchController.setMode(mode);
}

// Если сделать просто const query = appSearchController.query
// можно поймать обращение к переменной до её иниализации, так как создание класса
// и получение значения происходят в один тик
const query = computed({
  get: () => appSearchController?.query.value ?? '',
  set: (val) => {
    if (appSearchController) appSearchController.query.value = val;
  },
});

const isSearchInputFocused = computed({
  get: () => appSearchController?.isSearchInputFocused.value,
  set: (val) => {
    if (appSearchController) appSearchController.isSearchInputFocused.value = val;
  },
})

function clearQuery() {
  appSearchController.clearQuery();
}

const suggestions = computed(() => {
  return appSearchController.suggestions.value;
});
const isSuggestionsLoaded = computed(() => {
  return appSearchController.isSuggestionsLoaded.value;
});

const getSuggestionsAndShowResultsDebounced = useDebounceFn(async () => {
  await appSearchController.getSuggestionsAndShowResults();
}, 300);

const getSuggestionsAndShowResults = async () => {
  await appSearchController.getSuggestionsAndShowResults();
};

watch(query, () => {
  if (!isSearchInputFocused.value) return
  getSuggestionsAndShowResultsDebounced();
});

const isSuggestionsEmpty = computed(() => appSearchController.isSuggestionsEmpty.value)

export function useAppSearch() {
  return {
    searchResultsPopup,
    appSearchController,
    isResultsOpened,
    isResultsInMenuMode,
    isResultsInPopupMode,
    toggleSearchResults,
    closeSearchResults,
    setSearchResultsMode,
    openSearchResults,
    query,
    clearQuery,
    suggestions,
    isSuggestionsLoaded,
    getSuggestionsAndShowResults,
    getSuggestionsAndShowResultsDebounced,
    isSuggestionsEmpty,
    isSearchInputFocused,
  };
}
